import React from 'react';
import { useParams } from 'react-router-dom';
import { SubmissionPage } from './submission-page';
import { useCurrentUser } from '../../common/current-user';

const SubmissionPageContainer = () => {
  // @ts-expect-error [MIGRATION-SUPPRESSION]: TS2339
  const { urlId } = useParams();
  const user = useCurrentUser();
  return <SubmissionPage urlId={urlId || ''} currentUser={user} />;
};

export { SubmissionPageContainer };
export default SubmissionPageContainer;
